export default __webpack_public_path__ + "static/media/3086.ef5452b0.jpg";